module.exports = __webpack_public_path__ + "static/img/version-img.9518edb.png";


//////////////////
// WEBPACK FOOTER
// ./static/deposit/version-img.png
// module id = ijLr
// module chunks = 1